.breadcrumbs {
	display: flex;
	align-items: center;
	gap: var(--size-4);
	min-width: 0;
	min-height: 40px;
	margin: -6px 0;
	white-space: nowrap;

	.slash::before {
		content: "";
		display: block;
		width: 8px;
		height: 16px;
		background: var(--color-text-silent);
		clip-path: polygon(0% 100%, 2px 100%, 100% 0%, calc(100% - 2px) 0%);
	}

	> *:not([popover]) {
		display: flex;
		align-items: center;
		gap: var(--size-3);
		flex-shrink: 0;
		color: var(--color-text);

		button&,
		a& {
			text-decoration: none;
			font-weight: 600;
			border-radius: var(--radius-md);
			padding: var(--size-2) var(--size-3);
			margin: 0 -6px;

			&:hover,
			&:focus-visible {
				background-color: var(--color-surface);
			}
			transition: background-color 0.1s ease;
		}
	}
}
